import '../src/frontend/styles/tailwind.css'
import '@stripe/stripe-js'
import { configure } from 'mobx'

configure({
  enforceActions: 'never',
})
